// extracted by mini-css-extract-plugin
export default {"root":"Signups__root--9OOHhL"};